import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';

import { ContentSpacing } from '@estee/elc-base-theme';
import { ServiceView } from '@estee/elc-service';
import { USER_PROFILE_WELCOME } from '@estee/elc-service-view-names';

import { widthMarginSetup } from '~components/CommonStyles';
import { serviceName } from '~setup/packageInfo';
import { classes } from '~utils/Classes';
import { sidebarSections as sdb } from '~views/sidebar/sections';

interface IWelcome {
    welcomeBack: string;
}

const WelcomeWrapper = styled.div`
    ${widthMarginSetup}
    display: grid;
    grid-template-columns: 1fr 0.25fr;
    padding: 0 0 ${ContentSpacing.space20};
    height: fit-content;
    grid-area: ${sdb.welcome};
`;

export const TEST_ID_SIDEBAR_WELCOME = 'account-sidebar-welcome';
const welcomeClass = classes('account-sidebar-welcome');

export const Welcome = observer(function Welcome({ welcomeBack }: IWelcome) {
    return (
        <WelcomeWrapper className={welcomeClass} data-test-id={TEST_ID_SIDEBAR_WELCOME}>
            <ServiceView
                name={USER_PROFILE_WELCOME}
                serviceName={serviceName}
                config={{ welcomeBack }}
            />
        </WelcomeWrapper>
    );
});
